// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__mu6WC","logo":"styles_logo__m53wM","small":"styles_small__WF94F","large":"styles_large__EURZi","progress":"styles_progress__BcV1w"};